/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { CameraStreamSettings } from './CameraStreamSettings';
export type InlineStreamSettings = {
    stream_settings: CameraStreamSettings;
    single_pass?: boolean,
};
export const EmptyInlineStreamSettings: InlineStreamSettings = {
    stream_settings: {},
    single_pass: undefined,
};
